import { useEffect, useState } from "react";
import { PrivacyPolicyFooter } from "./PrivacyPolicyFooter";
import { PrivacyPolicyHeader } from "./PrivacyPolicyHeader";
import { PrivacyPolicySidebar } from "./PrivacyPolicySidebar";
import { privacyPolicysections } from "./privacyPolicyData";
import { PrivacyPolicyContent } from "./PrivacyPolicyContent";

const PrivacyPolicy = () => {
  const [activeId, setActiveId] = useState(privacyPolicysections[0].id);

  // Highlight the section currently in view
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActiveId(visible[0].target.id);
      },
      { rootMargin: "-10% 0px -70% 0px", threshold: 0 },
    );

    privacyPolicysections.forEach((s) => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-[#f0f2f7] font-sans leading-[1.6] text-[#1f2a4a] antialiased">
      {/* Header */}
      <PrivacyPolicyHeader />

      {/* Middle content: aside on the left, document on the right */}
      <main className="mx-auto my-6 flex max-w-[1080px] items-start gap-6 px-7 max-[900px]:flex-col max-[640px]:px-4">
        <PrivacyPolicySidebar activeId={activeId} />
        <PrivacyPolicyContent />
      </main>

      {/* Footer */}
      <PrivacyPolicyFooter />
    </div>
  );
};

export default PrivacyPolicy;
